<template>
	<div class="c-body">
		<div class="c-body__title">
			<h2>
				MultiMentions
				<button @click="toggleHelp" :class="{'-active': showHelp}">
					<c-icon :name="'question-circle'"></c-icon>
				</button>
			</h2>
		</div>
		<div class="c-help">
			<div class="c-help__inner">
				<div class="e-section">
					<p>
						多数のユーザーに向けた一括メンションツイートを分割生成するジェネレータです。
					</p>
					<ul>
						<li>宛先（リスト）とメッセージを入力して生成ボタンを押すと結果が出力されます</li>
						<li>宛先はアカウント名とおぼしき文字列を自動抽出します</li>
						<li>メッセージ内のURL文字列は t.co で短縮された物として計算されます</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="c-body__inner">
			<div class="e-section">
				<div class="e-grid -triple -center">
					<div class="col">
						<label class="c-multimentions-input">
							<div class="c-multimentions-input__title">
								<span class="c-multimentions-input__label">@宛先</span>
							</div>
							<textarea class="e-input-text -full" placeholder="@mach3ss, @codogue" v-model="accounts"></textarea>
						</label>
					</div>
					<div class="col">
						<label class="c-multimentions-input">
							<div class="c-multimentions-input__title">
								<span class="c-multimentions-input__label">メッセージ</span>
								<span class="c-multimentions-input__counter" :class="{'-caution':140 < messageLength}">{{140-messageLength}}</span>
							</div>
							<textarea class="e-input-text -full" placeholder="メッセージを入力" v-model="message" :class="{'-invalid': 140 < messageLength}"></textarea>
						</label>
					</div>
					<div class="col">
						<p>
							<button class="e-button -primary -full" @click="generate">メッセージ生成</button>
						</p>
						<label class="e-label">
							<input type="checkbox" v-model="options.insertPeriod">
							<span class="label">先頭にピリオドをつける</span>
						</label>
					</div>
				</div>
			</div>
			<div class="e-section">
				<div class="c-multimentions-account-list">
					<ul class="c-multimentions-account-list__list">
						<li class="c-multimentions-account-list__item" v-for="item in accountList">{{item}}</li>
					</ul>
				</div>
			</div>
			<hr class="e-hr">
			<div class="e-section">
				<transition name="slide-in">
					<div class="c-error-list" v-if="errors.length">
						<ul class="c-error-list__list">
							<li class="c-error-list__item" v-for="error in errors">
								<c-icon :name="'error'"></c-icon>
								{{error.message}}
							</li>
						</ul>
					</div>
				</transition>
				<transition name="slide-in">
					<div class="c-multimentions-result" v-if="results.length">
						<ul class="c-multimentions-result__list">
							<li class="c-multimentions-result__item" v-for="item in results" :key="item.key" :class="{'-disabled': item.done}">
								<div class="message">
									<textarea class="e-input-text -full" readonly v-model="item.message"></textarea>
								</div>
								<div class="button">
									<button class="c-multimentions-result__button-tweet" @click="tweet(item.message)">@</button>
								</div>
							</li>
						</ul>
					</div>
				</transition>
			</div>
		</div>
	</div>
</template>

<script>

import mCommon from "../mixins/common";


export default {
	mixins: [
		mCommon
	],
	data (){
		return {
			options: {
				insertPeriod: false,
				maxLength: 140,
				urlLength: 23,
				urlPattern: /(^|\s)(https?|ftp)(:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+)/g,
				shareUrl: "https://twitter.com/intent/tweet"
			},
			message: "",
			accounts: "",
			// message: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Vero debitis, rem molestiae enim! http://example.com",
			// accounts: "foo,bar,foo_bar,foobar,baz,foo_bar_baz,foobarbaz,foo_bar_baz_foo,barbaz,bar_baz",
			results: [],
			errors: []
		}
	},
	computed: {
		messageLength (){
			var diff = 0,
				m = this.message.match(this.options.urlPattern);

			if(m){
				m.map((r) => {
					diff += (r.length - this.options.urlLength);
				});
			}
			if(this.options.insertPeriod){
				diff -= 2;
			}
			return Array.from(this.message).length - diff;
		},
		accountList (){
			var list = [];
			this.accounts.replace(/[a-z0-9_]{1,15}/g, function(name){
				list.push("@" + name);
			});
			return list;
		}
	},
	methods: {
		generate (){
			var list = [],
				limit = this.options.maxLength - this.messageLength,
				length = 0;

			this.results = [];
			this.results.splice(0);

			this.errors = [];
			this.errors.splice(0);

			if(limit < 3){
				this.errors.push(new Error("メッセージが長すぎます"));
				return;
			}

			this.accountList.map((account, index, all) => {
				var last = (index + 1) === all.length;

				// そもそも無理なアカウントの長さの場合はここでエラーを追加
				if(account.length > limit){
					this.errors.push(new Error(`${account}宛のメッセージは文字数制限により生成できませんでした`));
					return;
				}

				// 文字数チェック
				length += account.length + 1;

				// 超過してたら list に push せずに結果を追加して返す
				if(length > limit){
					this.pushResult(this.generateTweet(list));
					// 初期化
					list = [account];
					length = account.length + 1;

					if(last){
						this.pushResult(this.generateTweet(list));
					}
					return;
				}

				// リストの最後の場合はpushしてから処理
				if(last){
					list.push(account);
					this.pushResult(this.generateTweet(list));
					return;
				}

				list.push(account);
			});
		},

		generateTweet (list){
			var t = this.options.insertPeriod ? ". " : "";
			t += list.join(" ") + " ";
			t += this.message;
			return t;
		},

		pushResult (message){
			this.results.push({
				key: $.now(),
				message: message,
				done: false
			});
		},

		tweet (message){
			var url = [
				this.options.shareUrl,
				$.param({
					text: message
				})
			].join("?");

			window.open(url);

			this.results = this.results.map((item) => {
				if(message === item.message){
					item.done = true;
				}
				return item;
			});
		}
	}
}
	
</script>


// WEBPACK FOOTER //
// multimentions.vue?172ab86f